/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { useRoutesStore } from '@/store/modules/routes';
import { useSettingsStore } from '@/store/modules/settings';
import variables from '@vab/styles/variables/variables.module.scss';
import { defaultOpeneds, uniqueOpened } from '@/config';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    layout: {
      type: String,
      default: 'vertical'
    }
  },

  setup(__props, {
    expose
  }) {
    expose();
    const props = __props;
    const settingsStore = useSettingsStore();
    const {
      collapse
    } = storeToRefs(settingsStore);
    const routesStore = useRoutesStore();
    const {
      getRoutes: routes,
      getActiveMenu: activeMenu,
      getPartialRoutes: partialRoutes
    } = storeToRefs(routesStore);
    const handleRoutes = computed(() => {
      return props.layout === 'comprehensive' ? partialRoutes.value : routes.value.flatMap(route => route.meta.levelHidden && route.children ? [...route.children] : route);
    });
    const __returned__ = {
      props,
      settingsStore,
      collapse,
      routesStore,
      routes,
      activeMenu,
      partialRoutes,
      handleRoutes,
      variables,
      defaultOpeneds,
      uniqueOpened
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }

});